export enum WorkspaceNonTaggableType {
    LINK = 'WORKSPACE_LINK',
    APP = 'APP',
    STORY = 'WORKSPACE_STORY',
    UNKNOWN = 'UNKNOWN',
}
